module.exports = __webpack_public_path__ + "img/bg-index.49b8cf35.png";